import React from 'react'
import styled from '@emotion/styled'
import { number } from 'prop-types'

import { Star } from '../svgs/Star'

const RatingContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: auto;
`
StarRating.propTypes = {
	rating: number.isRequired,
	totalNumOfStars: number,
}
/**
 * Star Rating Component, displays filled in stars based on rating system
 * Can currently support half and whole ratings
 *
 * @param {Number} props.rating :: average rating that should be displayed
 * @param {Number} props.totalNumOfStars :: number of stars that the rating is out of
 */
export function StarRating({ rating, totalNumOfStars = 5 }) {
	return (
		<RatingContainer>
			{[...Array(totalNumOfStars)].map((star, i) => {
				const currentStar = i + 1
				if (Math.floor(rating) >= i + 1) {
					return <Star key={i} variant="full" />
				} else if (currentStar > rating && currentStar - 1 < rating) {
					return <Star key={i} variant="half" />
				} else {
					return <Star key={i} />
				}
			})}
		</RatingContainer>
	)
}
